import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Package, FileText, Check } from 'lucide-react';
export function OfferSection() {
  return <SectionWrapper className="bg-cyber-dark/30 border-t border-cyber-purple/20" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <div className="text-center mb-12" data-id="element-184">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cyber-purple/10 border border-cyber-purple mb-6 shadow-neon-purple" data-id="element-185">
            <Package className="w-8 h-8 text-cyber-purple" data-id="element-186" />
          </div>
          <h2 className="text-3xl md:text-4xl text-white mb-4 font-mono" data-id="element-187">
            SISTEMA DE TRANSFORMACIÓN{' '}
            <span className="text-cyber-purple text-shadow-purple" data-id="element-188">
              SOCIAL HACKER
            </span>
          </h2>
          <p className="text-gray-400" data-id="element-189">
            Hoy no solo te llevas un libro, te llevas el protocolo completo.
          </p>
        </div>

        <div className="bg-cyber-black border border-cyber-purple/50 rounded-xl p-1 relative overflow-hidden" data-id="element-190">
          {/* Animated border line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyber-purple to-transparent opacity-50" data-id="element-191"></div>

          <div className="bg-cyber-dark/80 rounded-lg p-6 md:p-8" data-id="element-192">
            <div className="flex items-start gap-4" data-id="element-193">
              <div className="bg-cyber-purple/20 p-3 rounded-lg border border-cyber-purple/30 shrink-0" data-id="element-194">
                <FileText className="w-6 h-6 text-cyber-purple" data-id="element-195" />
              </div>

              <div data-id="element-196">
                <h3 className="text-xl text-white font-mono font-bold mb-2 flex items-center gap-2" data-id="element-197">
                  Ebook Principal: Social Hacker v1.0{' '}
                  <span className="text-xs bg-cyber-purple/20 text-cyber-purple px-2 py-1 rounded border border-cyber-purple/30" data-id="element-198">
                    (60 Págs)
                  </span>
                </h3>
                <p className="text-gray-400 mb-4" data-id="element-199">
                  El mapa exacto de 30 días para reprogramar tu cerebro y
                  hackear tu ansiedad social.
                </p>

                <ul className="space-y-2 font-mono text-sm" data-id="element-200">
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-201">
                    <Check className="w-4 h-4 text-cyber-neon" data-id="element-202" />
                    <span data-id="element-203">Protocolo de Micro-Exposición paso a paso</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-204">
                    <Check className="w-4 h-4 text-cyber-neon" data-id="element-205" />
                    <span data-id="element-206">
                      Scripts de 3 segundos para iniciar conversaciones
                    </span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-207">
                    <Check className="w-4 h-4 text-cyber-neon" data-id="element-208" />
                    <span data-id="element-209">Técnicas de hackeo del sistema nervioso</span>
                  </li>
                </ul>

                <div className="mt-6 pt-4 border-t border-gray-800 text-right" data-id="element-210">
                  <span className="text-gray-500 line-through mr-2" data-id="element-211">
                    Valor Normal: $42.50
                  </span>
                  <span className="text-cyber-neon font-bold font-mono" data-id="element-212">
                    Valor Hoy: $6.36
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}